import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const { user, apiKey, logout, generateApiKey } = useAuth();
  const [showApiKey, setShowApiKey] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCopyApiKey = () => {
    if (apiKey) {
      navigator.clipboard.writeText(apiKey.key);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleGenerateNewApiKey = async () => {
    setLoading(true);
    await generateApiKey();
    setLoading(false);
    setShowApiKey(true); // Show the key after generating
  };

  return (
    <div>
      <div className="max-w-4xl mx-auto p-10">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Dashboard</h1>
          <p className="text-gray-600">Manage your API credentials</p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 mb-6 p-6">
          <div className="flex items-center mb-6">
            {user?.profile_picture && (
              <img 
                src={user.profile_picture} 
                alt="Profile" 
                className="w-12 h-12 rounded-full mr-4"
              />
            )}
            <div>
              <h2 className="text-xl font-semibold">{user?.name || 'User'}</h2>
              <p className="text-gray-600">{user?.email}</p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-4">
            <h3 className="text-lg font-medium mb-2">Your API Key</h3>
            
            {apiKey ? (
              <div className="mb-4">
                <div className="flex items-center mb-2">
                  <div className="relative flex-grow mr-2">
                    <input
                      type={showApiKey ? "text" : "password"}
                      value={apiKey.key}
                      readOnly
                      className="w-full p-2 pr-10 border border-gray-300 rounded"
                    />
                    <button
                      className="absolute right-2 top-2 text-gray-500 hover:text-gray-700"
                      onClick={() => setShowApiKey(!showApiKey)}
                    >
                      {showApiKey ? (
                        <span>🙈</span>
                      ) : (
                        <span>👁️</span>
                      )}
                    </button>
                  </div>
                  <button
                    className="px-3 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                    onClick={handleCopyApiKey}
                  >
                    {copied ? "Copied!" : "Copy"}
                  </button>
                </div>
                <p className="text-sm text-gray-600 mb-4">
                  This API key gives you access to all API endpoints. Keep it secure.
                </p>
                <button
                  className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
                  onClick={handleGenerateNewApiKey}
                  disabled={loading}
                >
                  {loading ? "Generating..." : "Generate New API Key"}
                </button>
                <p className="text-sm text-gray-500 mt-1">
                  Warning: This will invalidate your current API key.
                </p>
              </div>
            ) : (
              <div className="mb-4">
                <p className="text-gray-600 mb-2">You don't have an API key yet.</p>
                <button
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  onClick={handleGenerateNewApiKey}
                  disabled={loading}
                >
                  {loading ? "Generating..." : "Generate API Key"}
                </button>
              </div>
            )}
          </div>

          <div className="mt-6 pt-4 border-t border-gray-200">
            <div className="flex justify-between">
              <Link
                to="/docs"
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                View API Documentation
              </Link>
              <button
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
                onClick={logout}
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 